<template>
  <v-menu v-model="menu" :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-bind="attrs"
        v-on="on"
        type="text"
        v-model="selectedFarmId"
        :placeholder="$t('selectFarm')"
        outlined
        dense
        :disabled="disabled"
        :loading="loading"
        append-icon="mdi-menu-down"
        :error-messages="error"
      ></v-text-field>
    </template>
    <v-card>
      <v-toolbar flat class="pt-5">
        <v-text-field
          type="text"
          :placeholder="$t('searchFarm')"
          outlined
          dense
          v-model="search"
          @input="getFarms"
          class="mr-5"
        ></v-text-field>
        <v-spacer></v-spacer>
        <div class="mt-n5">
          <v-btn fab outlined x-small depressed color="primary" @click="page=page-1" :disabled="page==1"><v-icon>mdi-chevron-left</v-icon></v-btn>
        <v-btn fab outlined x-small depressed color="primary" @click="page=page+1" class="mx-2" :disabled="page==totalPages"><v-icon>mdi-chevron-right</v-icon></v-btn>
        </div>
      </v-toolbar>
      <v-card-text>
        
        <v-list-item-group color="primary" class="px-0">
          <v-list flat style="max-height: 250px; max-width: 500px;text-overflow: ellipsis;" class="overflow-y-auto">
            <template v-for="farm in farmList">
              <v-list-item
                :key="farm.farmNumber"
                @click="selectanimal(farm.farmNumber)"
                color="primary"
              >
                <v-list-item-content>
                  <v-list-item-title>{{
                    `${farm.farmNumber} (${farm.name || "N/A"})`
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-list-item-group>
      </v-card-text>
      <div class="gray2 py-3 primary--text text-center">
        <a
          @click="
            () => {
              $router.push({ name: 'My farm'});
            }
          "
          >View All Farms ({{ this.totalRecords }})
        </a>
      </div>
    </v-card>
  </v-menu>
</template>
<script>
import FarmService from "@/_services/farmService";

export default {
  mounted() {
    (this.selectedFarmId = this.value), this.getFarms();
  },
  props: {
    value: {
      required: false,
    },
    error: {
      required: false
    },
    disabled: {
      default: false
    }
  },
  watch: {
    value: {
      handler(val) {
        this.selectedFarmId = val;
      },
      deep: true,
    },
    page: {
      handler() {
        this.getFarms()
      }
    }
  },
  data() {
    return {
      menu: false,
      selectedFarmId: this.value,
      search: "",
      farmList: [],
      inputField: "",
      loading: false,
      page: 1,
      limit: 10,
      totalPages: 1,
      totalRecords: 0,
    };
  },

  methods: {
    getFarms() {
        this.loading = true;
        FarmService.getfarms(
            {
                sortBy: "",
                page: this.page,
                itemsPerPage: this.limit,
            },
            this.search
        ).then(res => {
            if (res.success) {
                this.farmList = res.data.rows;
                this.totalRecords =  res.data.totalRows;
                this.totalPages = Math.ceil(Number(this.totalRecords) / this.limit)
            }
            this.loading = false;
        })
        .catch( e => {
            console.log('f errror', e)
            this.loading = false;
        });
    },

    imageUrl(animal) {
      return animal?.img?.url || "/img/no_img.png";
    },
    selectanimal(animalId) {
      this.selectedFarmId = animalId;
      this.$emit("input", this.selectedFarmId);
      this.menu = false;
    },
  },
};
</script>
